import general from '../../utils/general';
import { useState, useRef, useEffect } from 'react';
import { LanguageKeys } from './translation';

export const useController = (props: any) => {
    const [currentLanguage, setCurrentLanguage] = useState<LanguageKeys>(general?.getAccount()?.preferredLanguage ?? 'PTBR');
    const allLanguageCodes = general.languages.map((lang) => lang.code) as LanguageKeys[];
    const [activeLoading, setActiveLoading] = useState(false);

    useEffect(() => {
        if(general.checkAuth()){
            setTimeout(() => {
                setCurrentLanguage(general?.getAccount()?.preferredLanguage ?? 'EN');
            }, 150);
        }
        else{ 
            general.logout();
        }
        if(props.active){
            setActiveLoading(true);
        }
    }, [props.active]);

    return {
        general,
        currentLanguage,
        setCurrentLanguage,
        allLanguageCodes,
        activeLoading,
        setActiveLoading
    };
}

export default useController;